import { Typography } from '@mui/material';
import useAuth from '../../hooks/useAuth';

interface LogoutProps {
  onLogout: () => void;
}

export default function Logout({ onLogout } : LogoutProps) {
  const { logout } = useAuth();

  const clickHandler = () => {
    logout();
    onLogout();
  };
  
  return (
    <Typography
      variant="body1"
      color="secondary"
      onClick={clickHandler}
      sx={{ mt: 2, display: 'block', textAlign: 'center', fontWeight: 'bold', cursor: 'pointer' }}
    >
      Logout
    </Typography>
  );
};

